import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setBreadcrumbsList } from 'src/store/breadcrumbs';

import { Convenient } from './convenient/Convenient';
import { InvestYourself } from '../aboutCompany/investYourself/InvestYourself';
import { Licenses } from '../home/licenses/Licenses';
import { Reliability } from './reliability/Reliability';
import { Advantages } from './advantages/Advantages';
import { SecurityMeasures } from './securityMeasures/SecurityMeasures';
import { AboutTeam } from './aboutTeam/AboutTeam';

import { BREADCRUMBS_DATA } from 'src/constants';

export const Platform = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBreadcrumbsList(BREADCRUMBS_DATA.PLATFORM));
  }, [dispatch]);

  return (
    <div className="platform">
      <Convenient />
      <Reliability />
      <Advantages />
      <AboutTeam />
      <SecurityMeasures />
      <Licenses />
      <InvestYourself />
    </div>
  );
};
